import { createContext } from "react"
import { AnimatePresence } from "framer-motion"
import _uniqueId from "lodash/uniqueId"

import useAnimatedWindow from "hooks/window/useAnimatedWindow"

import AnimatedWindow from "components/presenters/common/AnimatedWindow"

export const AnimatedWindowStateContext = createContext([])

export const AnimatedWindowCallbackContext = createContext({
  openWindow: () => {},
  closeWindow: () => {},
  id: "",
})

const AnimatedWindowProvider = ({ children }) => {
  const { openedWindows, setOpenedWindows } = useAnimatedWindow()
  const animatedWindowId = _uniqueId("animated-window-")

  const openWindow = ({ id, Component, headerProps }) => {
    setOpenedWindows((modals) => {
      return [...modals, { id: id || _uniqueId("animated-window-"), Component, headerProps }]
    })
  }

  const closeWindow = (currId) => {
    setOpenedWindows((windows) => {
      return windows.filter(({ id }) => id !== currId)
    })
  }
  return (
    <AnimatedWindowCallbackContext.Provider
      value={{ openWindow, closeWindow, id: animatedWindowId }}
    >
      <AnimatedWindowStateContext.Provider value={openedWindows}>
        {children}
        <AnimatePresence>
          {openedWindows.map(({ id, Component, headerProps }) => (
            <AnimatedWindow key={id} id={id} children={Component} headerProps={headerProps} />
          ))}
        </AnimatePresence>
      </AnimatedWindowStateContext.Provider>
    </AnimatedWindowCallbackContext.Provider>
  )
}

export default AnimatedWindowProvider
